const fb = require('../firebaseConfig.js')
import firebase from 'firebase/app';
import axios from 'axios'

const SERVER='https://orderupdates.kegseeker.com:5000/'

export function createArrayToInvoice(ordersToInvoice, company){

    var groupedArray=[]
    //Iterate over all orders
    for (var i=0; i<ordersToInvoice.length; i++){
        //To keep track of whether this pub was already found and we must append, or create a new group
        var foundPubArray=false
        //Iterate over groupedArray and see if pubid exists in one of them
        if(groupedArray.length>0){
            for (var j=0; j<groupedArray.length; j++){
                
                //Get order array for each pub
                var thisOrdersObject=groupedArray[j]
                //Check if pubid is the same
                if (thisOrdersObject.pubid==ordersToInvoice[i].pubid){
                    //Found an orders object for this pub
                    var thisPubOrdersArray=thisOrdersObject.orders
                    var invoicenumber=thisOrdersObject.invoicenumber
                    //Append to orders array
                    var thisOrder=ordersToInvoice[i]
                    //Add an empty tax field
                    thisOrder.tax=""
                    //Create itemName
                    thisOrder.itemName=thisOrder.beerName+' '+thisOrder.size

                    thisPubOrdersArray.push(thisOrder)
                    //Create new orders object
                    var newOrdersObject=thisOrdersObject
                    newOrdersObject.orders=thisPubOrdersArray
                    //Replace array element with new object
                    groupedArray.splice(j, 1, newOrdersObject)
                    foundPubArray=true
                }
            }
            //End of for loop over grouped orders array
        }
        //This pub was not found or grouped order array length was 0. Push.
        if(!foundPubArray){
            var newOrderToPush=ordersToInvoice[i]
            //Create itemName
            newOrderToPush.itemName=newOrderToPush.beerName+' '+newOrderToPush.size
            //Add an empty tax field
            newOrderToPush.tax=""
            //Order array for this pub
            var newOrderArray=[newOrderToPush]
            //Create invoice number
            var max=9999999999999999
            var min=1111111111111111
            var invoiceNumber=Math.floor(Math.random() * (max - min + 1)) + min;

            //Orders object for this pub
            var paymentInstructions="Please make checks payable to "+company
            var thisOrdersObject={pubid:newOrderToPush.pubid, pub:newOrderToPush.pub, brewerid:newOrderToPush.brewerid, brewer:newOrderToPush.brewer,invoicenumber:invoiceNumber, 
            billingaddress:ordersToInvoice[i].deliveryAddress, orders:newOrderArray, paymentinstructions:paymentInstructions}
            //Append to grouped array.
            groupedArray.push(thisOrdersObject)

        }
    }

    //Add four rows to each grouped array for user to enter any new items in the same invoice
    var emptyRow={}
    emptyRow.orderDate=""
    emptyRow.beerName=""
    emptyRow.orderQuantity=""
    emptyRow.totalCost=""
    emptyRow.tax=""
    emptyRow.itemName=""

    var groupedArrayWithEmptyRows=[]
    for (var j=0; j<groupedArray.length; j++){
        var newGroupWithEmptyRows=groupedArray[j]
        
        var thisOrderArray=newGroupWithEmptyRows.orders
        thisOrderArray.push(emptyRow)
        thisOrderArray.push(emptyRow)
        thisOrderArray.push(emptyRow)
        thisOrderArray.push(emptyRow)
        newGroupWithEmptyRows.orders=thisOrderArray
        groupedArrayWithEmptyRows.push(newGroupWithEmptyRows)
    }
    //End of orders array
    return groupedArrayWithEmptyRows

}

export function updateuserinfo(uid, zip){
    var mailApiKey = process.env.VUE_APP_email_apiKey
    var bodyFormData = new FormData();
    bodyFormData.set('uid', uid);
    bodyFormData.set('zip', zip);
    var url=SERVER+'updateuserinfo'
    axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data' }
        })
        .then(function (response) {
            //handle success
            //console.log(response);
        })
        .catch(function (response) {
            //handle error
            console.log(response);
        });
}


//Group orders by month
export function groupmonth(value, index, array){
    let bymonth={};
    var d = new Date(value['createdOn'].seconds*1000);
    console.log("Date = ")
    console.log(d)
    d = (d.getFullYear()-1970)*12 + d.getMonth();
    console.log("Months = ")
    console.log(d)
    bymonth[d]=bymonth[d]||[];
    bymonth[d].push(value);
   return bymonth
 }